/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Modal imports.
 */
import { Ratings } from 'src/app/onboarding/interface/global.model';

/**
 * Constant imports.
 */
import { RATINGS_TYPE, RATING_IS_ACTIVE, RATING_LEVEL } from './../../constants/app.constants';

/**
 * Used to set the different type of ratings.
 */
@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingsComponent implements OnInit {

  /**
   * Receive the ratings array.
   * type of rating radio, meter.
   * text labels for the ratings.
   */
  @Input() value: { rating: Ratings[]; type: number };
  @Input() isViewMode: boolean;
  @Input() textLabels: { start: string; end: string };
  @Input() prefilled = [];
  @Input() questionCode : string;

  /**
   * Send selected rating outside.
   */
  @Output() emitSelected: EventEmitter<Ratings> = new EventEmitter();

  public ratings: { rating: Ratings[]; type: number };

  /**
   * Constants for rating type, is active and rating levels.
   */
  public ratingType = RATINGS_TYPE;
  public ratingLevel = RATING_LEVEL;
  public ratingIsActive = RATING_IS_ACTIVE;

  ngOnInit(): void {
    this.ratings = JSON.parse(JSON.stringify(this.value));
    if (this.prefilled?.length) {
      const preFilledIndex = (Number(this.prefilled[0]?.textValue) - 1);
      this.setRating(preFilledIndex);
    }
  }

  /**
   * Receive the selected rating and perform action according to type of rating.
   */
  setRating(index: number): void {
    if (this.ratings.type === this.ratingType.RADIO) {
      this.setActiveStateForOne(index)
    } else {
      this.setActiveStateFromSelected(index);
    }
    this.sendSelected(index);
  }

  /**
   * Set rating according to radio button.
   */
  setActiveStateForOne(index: number): void {
    this.ratings.rating.forEach((val: Ratings, i: number) => {
      val.isActive = this.ratingIsActive.DISABLE;
      if (i === index) {
        val.isActive = this.ratingIsActive.ENABLE;
      }
    });
  }

  /**
   * Set rating according to meter rating.
   */
  setActiveStateFromSelected(index: number): void {
    this.ratings.rating.forEach((val: Ratings, i: number) => {
      val.isActive = this.ratingIsActive.DISABLE;
      if (i <= index) {
        val.isActive = this.ratingIsActive.ENABLE;
      }
    });
  }

  /**
   * Send selected rating outside.
   */
  sendSelected(index: number): void {
    this.emitSelected.emit(this.ratings.rating[index]);
  }

  checkIsViewMode(): boolean {
    return this.isViewMode;
  }

  /**
   * Track the indexed stream.
   */
  trackById(index, ques): void {
    return ques ? ques.id : undefined;
  }

  getSelected(index): boolean {
    return this.prefilled?.length ? (Number(this.prefilled[0]?.textValue) - 1) === index : false;
  }
}
